import { useState, useEffect } from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action.js";
import { useDispatch } from "react-redux";
import { styles } from "../../../stylesheets/simulateurs.css.js";
import "../../../stylesheets/simulateursBis.css";
import ButtonYesno from "../../../components/buttons/button.yesno.js";
import TextfieldNumber from "../../../components/textfields/textfield.number.js";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle.js";
import { ToolTipPerso } from "../../../components/selects/tooltip_perso.js";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques.js";
import SelectDepartement from "../../../components/selects/select.departement";
import SelectCommon from "../../../components/selects/select.common.js";
import PrimoAccedant from "../../../components/questions/PrimoAccedant";
import ConventionHonoraires from "../../../components/questions/ConventionHonoraires.js";
import DeboursQuestion from "../../../components/questions/DeboursQuestion.js";
import ButtonTextCustom from "../../../components/buttons/button.text.custom.js";
import Promesse from "../../../components/questions/Promesse.js";
import Pret from "../../../components/questions/Pret.js";


// Vente de bien immobilier démembré
// simulateur id 115

function Simulateur_115(props) {
  const dispatch = useDispatch();

  let currUser = JSON.parse(localStorage.getItem("user"));
  let currUserDep = 0;
  if (currUser.societe_zip.startsWith("97")) {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 3);
    currUserDep = parseInt(trimedZip);
  } else {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 2);
    currUserDep = parseInt(trimedZip);
  }
  
  const [departement, setDepartement] = useState(1);
  const [departementChiffre, setDepartementChiffre] = useState(0);
  const [primoAccedant, setPrimoAccedant] = useState(0);
  const [taxeIleDeFrance, setTaxeIleDeFrance] = useState(0);
  const [zrr, setZrr] = useState(0);
  const [typeDemembrement, setTypeDemembrement] = useState(0);
  const [typeVenteSelectionne, setTypeVenteSelectionne] = useState(null);
  const [montantVente, setMontantVente] = useState(0);
  const [valeurFiscalNP, setValeurFiscalNP] = useState(0)
  const [valeurFiscalUsufruit, setValeurFiscalUsufruit] = useState(0);
  const [valeurEconomique, setValeurEconomique] = useState(0);
  const [valeurEconomiqueNp, setValeurEconomiqueNp] = useState(0);
  const [valeurEconomiqueUsufruit, setValeurEconomiqueUsufruit] = useState(0);
  const [choixReserveUsage, setChoixReserveUsage] = useState(0);
  const [promesse, setPromesse] = useState(0);
  const [cautionSansGarantieHypo, setCautionSansGarantieHypo] = useState(0);
  const [simu114, setSimu114] = useState(null);
  const [montantPromesse, setMontantPromesse] = useState(0);
  const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
  const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);
  const [pretHypo, setPretHypo] = useState(0);
  const [pretsPro, setPretsPro] = useState(0);
  const [simu84, setSimu84] = useState(null);
  const [simu92, setSimu92] = useState(null);

  const [dependances, setDependancesState] = useState([]);
  useEffect(() => {
    if (simu84 !== undefined && simu84 !== null) setDependances(simu84);
  }, [simu84]);

  useEffect(() => {
    if (simu92 !== undefined && simu92 !== null) setDependances(simu92);
  }, [simu92]);

  useEffect(() => {
    if (simu114 !== undefined && simu114 !== null) setDependances(simu114);
  }, [simu114]);

  function setDependances(simu) {
    setInRedux("dependance", simu);
  }

    const handleChange = async (setter, value, key) => {
        if (setter === setDepartementChiffre) {
            if (!props.depsPrimoAccedants.includes(value)) {
                setPrimoAccedant(0);
            }
            setDepartementChiffre(value);
        } else {
        setter(value);
        setInRedux(setter, value, key);
        }
    };

    const handleChangeRemarque = async (value) => {
        localStorage.setItem("remarque", value)
    };
    
    const typeDemembre = [
        { id: 0, name: "Choisissez un type de vente"},
        { id: 1, name: "Acquisition conjointe usufruit / nue-propriété" },
        { id: 2, name: "Vente avec réserve d'usufruit ou droit d'usage et d'habitation sans rente" },
        { id: 3, name: "Vente d'usufruit" },
    ];

    const typeVente = [
        { id: "", name: "Choisissez un type d'immeuble"},
        { id: 1, name: "Hors copropriété" },
        { id: 2, name: "En copropriété" },
        { id: 3, name: "Terrain" },
        { id: 4, name: "Garage" },
    ];

    function setInRedux(setter, value, key) {
        if (props.isParent) {
            let object = {
                simulateurid: props.simulateur.id,
                departementid: parseInt(departement),
                inputs: {
                    type_demembrement : parseInt(typeDemembrement),
                    type_vente : parseInt(typeVenteSelectionne),
                    us_fiscale: parseInt(valeurFiscalUsufruit),
                    np_fiscale: parseInt(valeurFiscalNP),
                    primo_accedant: parseInt(primoAccedant),
                    taxe_ile_de_france: parseInt(taxeIleDeFrance),
                    zrr: parseInt(zrr),
                    montant_vente : parseInt(montantVente),
                    us_economique: parseInt(valeurEconomiqueUsufruit),
                    np_economique: parseInt(valeurEconomiqueNp),
                    reserve: parseInt(choixReserveUsage),
                    promesse: parseInt(promesse),
                    montant_promesse: parseInt(montantPromesse),
                    montant_deb_add: parseInt(montantDeboursAdditionnels),
                    debours_additionnels: parseInt(deboursAdditionnels),
                    convention_honoraires : parseInt(props.conventionHonoraires),
                },
                pdfInputs: {
                    nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
                    object_convention_honoraires : props.objectConventionHonoraires,
                    montant_convention_honoraires : parseInt(props.montantConventionHonoraires),
                    nom_signataire_convention_honoraires : props.nomSignataireConventionHonoraires,
                    adresse_signataire_convention_honoraires : props.adresseSignataireConventionHonoraires,
                },
                dependances: dependances,
            };
            //For values coming from components
            if (key) {
                if (key === "debours_additionnels") {
                    if (value === 0) {
                        setMontantDeboursAdditionnels(0)
                        Object.assign(object["inputs"], { montant_deb_add: 0 });
                    }
                    Object.assign(object["inputs"], { debours_additionnels: parseInt(value) });
                }
                if (key === "promesse") {
                    if (value === 0) {
                        setMontantPromesse(0)
                        Object.assign(object["inputs"], { montant_promesse: parseInt(0) });
                    }
                    Object.assign(object["inputs"], { promesse: parseInt(value) });
                }
                if (key === "montant_deb_add") { Object.assign(object["inputs"], { montant_deb_add: parseInt(value) }); }
                if (key === "montant_promesse") { Object.assign(object["inputs"], { montant_promesse: parseInt(value) }); }
                if (key === "primo_accedant") { Object.assign(object["inputs"], { primo_accedant: parseInt(value) }); }
            }

            //For internal settings
            if (setter === setDepartement) { object.departementid = parseInt(value); }
            if (setter === setTaxeIleDeFrance) { Object.assign(object["inputs"], { taxe_ile_de_france: parseInt(value) }); }
            if (setter === setZrr) { Object.assign(object["inputs"], { zrr: parseInt(value) }); }
            if (setter === setChoixReserveUsage) { Object.assign(object["inputs"], {reserve: parseInt(value)}); }
            if (setter === setTypeVenteSelectionne) { Object.assign(object["inputs"], {type_vente: parseInt(value)}); }
            if (setter === setMontantVente) { Object.assign(object["inputs"], {montant_vente: parseInt(value)}); }
            if (setter === setTypeDemembrement) { 
                Object.assign(object["inputs"], {type_demembrement: parseInt(value)});
                if (value !== typeDemembrement) {
                    setMontantVente(0)
                    Object.assign(object["inputs"], {montant_vente: 0});
                    setValeurFiscalNP(0)
                    Object.assign(object["inputs"], {np_fiscale: 0});
                    setValeurFiscalUsufruit(0)
                    Object.assign(object["inputs"], {us_fiscale: 0});
                    handleChange(setValeurEconomique, 0)
                }
            }
            if (setter === setValeurFiscalNP) { 
                Object.assign(object["inputs"], {np_fiscale: parseInt(value)});
                if (parseInt(typeDemembrement) === 2 && valeurEconomique === 0) {
                    setMontantVente(parseInt(value))
                    Object.assign(object["inputs"], {montant_vente: parseInt(value)}); 
                }
            }
            if (setter === setValeurFiscalUsufruit) { 
                Object.assign(object["inputs"], {us_fiscale: parseInt(value)});
                if (parseInt(typeDemembrement) === 3 && valeurEconomique === 0) {
                    setMontantVente(parseInt(value))
                    Object.assign(object["inputs"], {montant_vente: parseInt(value)}); 
                }
            }
            if (setter === setValeurEconomique && value === 0) {
                setValeurEconomiqueNp(0)
                Object.assign(object["inputs"], {np_economique: 0});
                setValeurEconomiqueUsufruit(0)
                Object.assign(object["inputs"], {us_economique: 0});
                setChoixReserveUsage(0)
                Object.assign(object["inputs"], {reserve: 0});
                if (parseInt(typeDemembrement) === 2) {
                    setMontantVente(valeurFiscalNP)
                    Object.assign(object["inputs"], {montant_vente: parseInt(valeurFiscalNP)}); 
                }
                if (parseInt(typeDemembrement) === 3) {
                    setMontantVente(valeurFiscalUsufruit)
                    Object.assign(object["inputs"], {montant_vente: parseInt(valeurFiscalUsufruit)}); 
                }
            }
            if (setter === setValeurEconomiqueNp) { 
                Object.assign(object["inputs"], {np_economique: parseInt(value)});
                if (parseInt(typeDemembrement) === 2 && valeurEconomique === 1) {
                    setMontantVente(parseInt(value))
                    Object.assign(object["inputs"], {montant_vente: parseInt(value)}); 
                }
            }
            if (setter === setValeurEconomiqueUsufruit) { 
                Object.assign(object["inputs"], {us_economique: parseInt(value)});
                if (parseInt(typeDemembrement) === 3 && valeurEconomique === 1) {
                    setMontantVente(parseInt(value))
                    Object.assign(object["inputs"], {montant_vente: parseInt(value)}); 
                }
            }

            if (setter === props.setConventionHonoraires) {
                if(value === 0){
                    props.setNombreConventionHonoraires(1);
                    props.setObjectConventionHonoraires(null);
                    props.setMontantConventionHonoraires(null);
                    props.setNomSignataireConventionHonoraires(null);
                    props.setAdresseSignataireConventionHonoraires(null);
                    Object.assign(
                        object["inputs"], { convention_honoraires : parseInt(value) },
                        object["pdfInputs"], {
                            nombre_convention_honoraires : null,
                            object_convention_honoraires : null,
                            montant_convention_honoraires : null,
                            nom_signataire_convention_honoraires : null,
                            adresse_signataire_convention_honoraires : null
                        },
                    );
                } else {
                    Object.assign(object["inputs"], { convention_honoraires : parseInt(value) });
                }
            }

            if (setter === props.setNombreConventionHonoraires) { Object.assign(object["pdfInputs"], { nombre_convention_honoraires : parseInt(value) }); }
            if (setter === props.setObjectConventionHonoraires) { Object.assign(object["pdfInputs"], { object_convention_honoraires : value }); }
            if (setter === props.setMontantConventionHonoraires) { Object.assign(object["pdfInputs"], { montant_convention_honoraires : parseInt(value)}); }
            if (setter === props.setNomSignataireConventionHonoraires) { Object.assign(object["pdfInputs"], { nom_signataire_convention_honoraires : value }); }
            if (setter === props.setAdresseSignataireConventionHonoraires) { Object.assign(object["pdfInputs"], { adresse_signataire_convention_honoraires : value }); }

            if( setter === setCautionSansGarantieHypo && value === 1) {
                setPretHypo(0);
                setPretsPro(0);
                setSimu84(null);
                setSimu84(null);
                setSimu92(null);
                setDependancesState([]);
                object.dependances = [];
            }

            if (setter === setCautionSansGarantieHypo && value === 0) {
                setSimu114(null);
                setDependancesState([]);
                object.dependances = [];
            }            
            if (setter === "dependance") {
                if (dependances.length > 0) object.dependances = dependances;

                if (value !== undefined) {
                    let validator = false;

                    for (let i = 0; i < object["dependances"].length; i++) {
                        if (object["dependances"][i]?.simulateurid === value.simulateurid) {
                            object.dependances[i] = value;
                            validator = true;
                        }
                    }

                    if (validator === false) {
                        object.dependances.push(value);
                    }

                    setDependancesState(object.dependances);
                }
            }
            //Logique de réinitialisation des prêts
            if (setter === setPretHypo && value === 0) {
                setSimu84(null);
                setSimu92(null);
                setDependancesState([]);
                object.dependances = [];
            }
            if (setter === setPretsPro && value === 0) {
                setSimu84(null);
                setDependancesState([]);
                object.dependances = [];
            } else if (setter === setPretsPro && value === 1) {
                setSimu92(null);
                setDependancesState([]);
                object.dependances = [];
            }
        
            if (props.isParent) {
                dispatch(setSimulateurObject(object));
            } else {
                // process child simu
            }
        }
    }

    return (
        <div style={styles.container}>
            <div className="cardSimulateur">
                <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id}/>

                <TextfieldRemarques handleChange={handleChangeRemarque}/>

                <p style={styles.cardSubTitle}>
                    Pour la vente, acte tarifé au titre du Tableau 5, n° 54 (Art A444-91). Prêt aux particuliers associé acte
                    tarifé au titre du Tableau 5, n° 137 (Art A444-143). Prêt aux professionnels associé acte tarifé au titre du
                    Tableau 5, n° 128 (Art A444-139). Cautionnement associé acte tarifé au titre du Tableau 5, n° 111 (Art
                    A444-127).
                </p>

                {props?.isParent === true && props.departements !== "" ? (
                    <>
                        <div className="cardRow">
                        <div style={styles.cardElemVerticalyCenter}>Département :</div>

                        <SelectDepartement
                            items={props.departements}
                            nameField={"name"}
                            defaultValue={currUserDep}
                            optionValue={"id"}
                            handleChange={handleChange}
                            setter={setDepartement}
                            setDepartementChiffre={setDepartementChiffre}
                        />
                        </div>
                        <div style={styles.cardRowSpecialMessage}>
                        La taxe départementale utilisée pour vos calculs est bien celle qui a été votée dans votre département. Attention de bien penser à indiquer le bon département lorsque vous effectuez une vente sur un département qui n’est pas le votre.
                        </div>
                    </>
                ) : (
                    <></>
                )}

                {props.depsTaxeIleFrance.includes(departement) ? (
                    <div className="cardRow">
                        <div style={styles.cardElemVerticalyCenter}>
                        Mutation soumise à la taxe additionnelle de 0.6% selon l'article 1599 sexies du CGI ?
                        <ToolTipPerso
                            title={
                            "Attention : Cette taxe ne s’applique que dans certains cas. Se référer au texte en vigueur qui les précise : art 1599 sexies du CGI. \n" +
                            "Taxe additionnelle aux droits d'enregistrement ou à la taxe de publicité foncière exigible sur les mutations à titre onéreux de locaux mentionnés à l'article L. 520-1 du code de l'urbanisme et situés en IDF. \n" + 
                            "Le taux de la taxe est fixé à 0,6 %. \nCette taxe s’applique aux :\n - locaux à usage de bureaux ;\n - locaux commerciaux ;\n - locaux de stockage. \nCette taxe ne s'applique pas :\n" + 
                            " - aux mutations à titre onéreux soumises à la taxe sur la valeur ajoutée ;\n - aux mutations exonérées de droits d'enregistrement ou de taxe de publicité foncière ;\n" + 
                            " - aux mutations d'immeubles sis hors de la région d'Île-de-France, y compris lorsque les actes translatifs de ces propriétés sont soumis à la formalité de l'enregistrement en Île-de-France ;\n" + 
                            " - aux opérations qui ne constituent pas une vente ou une opération assimilée."
                            }
                        />
                        </div>
                        <div>
                        <ButtonYesno
                            handleChange={handleChange}
                            setter={setTaxeIleDeFrance}
                            fieldUndefined={false}
                            defaultValue={0}
                        />
                        </div>
                    </div>
                ) : (
                    <>
                        {props.depsZrr.includes(departement) ? (
                        <div className="cardRow">
                            <div style={styles.cardElemVerticalyCenter}>
                            Habitation située dans une zone de revitalisation rurale ? (faisant l'objet d'une réduction de droits)
                            </div>
                            <div>
                            <ButtonYesno handleChange={handleChange} setter={setZrr} fieldUndefined={false} defaultValue={0} />
                            </div>
                        </div>
                        ) : (
                        <></>
                        )}
                    </>
                )}
                {props.depsPrimoAccedants.includes(departementChiffre) ? (
                    <PrimoAccedant
                        handleChange={handleChange}
                        setPrimoAccedant={setPrimoAccedant}
                    />
                ) : (
                    <></>
                )}

                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>Quel type d'immeuble ? </div>
                    <SelectCommon
                        items={typeVente}
                        defaultValue={""}
                        nameField={"name"}
                        optionValue={"id"}
                        handleChange={handleChange}
                        setter={setTypeVenteSelectionne}
                    />
                </div>

                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>Quel type de vente s'agit-t-il ? </div>
                    <SelectCommon
                        items={typeDemembre}
                        defaultValue={0}
                        nameField={"name"}
                        optionValue={"id"}
                        handleChange={handleChange}
                        setter={setTypeDemembrement}
                    />
                </div>

                {parseInt(typeDemembrement) === 1 ?(
                    <div className="cardRow">
                        <div style={styles.cardElemverticalyCenter}>
                            <>Quel est le montant global du prix d'acquisition ?</>
                        </div>
                        <TextfieldNumber
                            handleChange={handleChange}
                            type={"number"}
                            placeholder={"Indiquer le montant"}
                            setter={setMontantVente}                     
                        />
                    </div>
                ) : null}
                   
                {parseInt(typeDemembrement) === 1 || parseInt(typeDemembrement) === 3 ? (
                    <div className="cardRow">
                    <div style={styles.cardElemverticalyCenter}>
                        Renseignez la valeur de l'usufruit fiscal :
                        <ToolTipPerso
                            title={
                                <>
                                Lien vers le <a href="https://notaire-langloys.com/categorie/autres/others/105" target="_blank" rel="noopener noreferrer">simulateur</a> pour calculer la valeur de l'usufruit fiscal.
                                </>
                            }
                        />
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer la valeur"}
                        setter={setValeurFiscalUsufruit}
                        defaultValue={valeurFiscalUsufruit}
                    />
                </div>
                ) : null}
                {parseInt(typeDemembrement) === 1 || parseInt(typeDemembrement) === 2 ? (
                    <div className="cardRow">
                        <div style={styles.cardElemverticalyCenter}>
                            Renseignez la valeur de la nue-propriété fiscale :
                            <ToolTipPerso
                                title={
                                    <>
                                    Lien vers le <a href="https://notaire-langloys.com/categorie/autres/others/105" target="_blank" rel="noopener noreferrer">simulateur</a> pour calculer la valeur de la nue-propriété fiscale.
                                    </>
                                }
                            />
                        </div>
                        <TextfieldNumber
                            handleChange={handleChange}
                            type={"number"}
                            placeholder={"Indiquer la valeur"}
                            setter={setValeurFiscalNP}
                            defaultValue={valeurFiscalNP}
                        />
                    </div>
                ) : null}
                <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>
                        Souhaitez-vous faire le calcul selon la valeur économique ?
                    </div>
                    <div>
                        <ButtonYesno handleChange={handleChange} setter={setValeurEconomique} fieldUndefined={false} defaultValue={valeurEconomique} />
                    </div>
                </div>
                {parseInt(typeDemembrement) === 2 && valeurEconomique === 1 ? (
                    <div className="cardRow">
                        <div style={styles.cardElemVerticalyCenter}>
                            Est-ce une vente avec :
                        </div>
                        <div>
                            <ButtonTextCustom handleChange={handleChange} setter={setChoixReserveUsage} defaultValue={0} val1={"Réserve d'usufruit"} val2={"Droit d'usage et d'habitation"}/>
                        </div>
                    </div>
                ) : null }
                
                {parseInt(valeurEconomique) === 1 ? (
                    <>
                        {parseInt(typeDemembrement) === 1 || parseInt(typeDemembrement) === 3 ? (
                            // Cas 1 Acquisition conjointe usufruit / nue-propriété
                            // Cas 3 : Vente d'usufruit
                            <div className="cardRow">
                                <div style={styles.cardElemverticalyCenter}>
                                    Renseignez la valeur de l'usufruit économique :
                                    <ToolTipPerso
                                        title={
                                            <>
                                                Lien vers le <a href="https://notaire-langloys.com/categorie/autres/others/113" target="_blank" rel="noopener noreferrer">simulateur</a> pour calculer la valeur de l'usufruit économique.
                                            </>
                                        }
                                    />
                                </div>
                                <TextfieldNumber
                                    handleChange={handleChange}
                                    type={"number"}
                                    placeholder={"Indiquer la valeur"}
                                    setter={setValeurEconomiqueUsufruit}                      
                                />
                            </div>
                        ) : null}
                        {parseInt(typeDemembrement) === 1 || parseInt(typeDemembrement) === 2 ? (
                            // Cas 1 Acquisition conjointe usufruit / nue-propriété
                            // Cas 2 : Vente avec réserve d'usufruit ou droit d'usage et d'habitation sans rente
                            <div className="cardRow">
                                <div style={styles.cardElemverticalyCenter}>
                                    Renseignez la valeur de la nue-propriété économique :
                                    <ToolTipPerso
                                        title={
                                            <>
                                                Lien vers le <a href="https://notaire-langloys.com/categorie/autres/others/113" target="_blank" rel="noopener noreferrer">simulateur</a> pour calculer la valeur de la nue-propriété économique.
                                            </>
                                        }
                                    />
                                </div>
                                <TextfieldNumber
                                    handleChange={handleChange}
                                    type={"number"}
                                    placeholder={"Indiquer la valeur"}
                                    setter={setValeurEconomiqueNp}                      
                                />
                            </div>
                        ) : null} 
                    </>
                ) : null}

                <Promesse
                    handleChange={handleChange}
                    setPromesse={setPromesse}
                    promesse={promesse}
                    setMontantPromesse={setMontantPromesse}
                />

                <DeboursQuestion
                    handleChange={handleChange}
                    deboursAdditionnels={deboursAdditionnels}
                    setDeboursAdditionnels={setDeboursAdditionnels}
                    setMontantDeboursAdditionnels={setMontantDeboursAdditionnels}
                />                
                <Pret
                    pretHypo={pretHypo}
                    setPretHypo={setPretHypo}
                    pretsPro={pretsPro}
                    setPretsPro={setPretsPro}
                    withPretsProChoice={true}
                    setSimu84={setSimu84}
                    setSimu92={setSimu92}
                    cautionSansGarantieHypo={cautionSansGarantieHypo}
                    setCautionSansGarantieHypo={setCautionSansGarantieHypo}
                    setSimu114={setSimu114}                    
                    simulateur={props.simulateur}
                    departementId={departement}
                    contentDep={setDependancesState}
                    handleChange={handleChange}
                />

                <ConventionHonoraires
                    handleChange={handleChange}
                    conventionHonoraires={props.conventionHonoraires}
                    setConventionHonoraires={props.setConventionHonoraires}
                    nombreConventionHonoraires={props.nombreConventionHonoraires}
                    setNombreConventionHonoraires={props.setNombreConventionHonoraires}
                    objectConventionHonoraires={props.objectConventionHonoraires}
                    setObjectConventionHonoraires={props.setObjectConventionHonoraires}
                    montantConventionHonoraires={props.montantConventionHonoraires}
                    setMontantConventionHonoraires={props.setMontantConventionHonoraires}
                    nomSignataireConventionHonoraires={props.nomSignataireConventionHonoraires}
                    setNomSignataireConventionHonoraires={props.setNomSignataireConventionHonoraires}
                    adresseSignataireConventionHonoraires={props.adresseSignataireConventionHonoraires}
                    setAdresseSignataireConventionHonoraires={props.setAdresseSignataireConventionHonoraires}
                />
            </div>
        </div>
    )
}

export default Simulateur_115;
